import { Order } from '@tokenlon/v6-sdk'
import V6OrderPreview from './V6OrderPreview'
import { useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'

interface OrderPreviewProps {
  order: Order
  slippage: number
  isUseAllowanceTarget: boolean
  setLockOrder: (value: null) => void
  setIsUserEdited: (isUserEdited: boolean) => void
}

const OrderPreview: React.FC<OrderPreviewProps> = ({
  order,
  slippage,
  isUseAllowanceTarget,
  setLockOrder,
  setIsUserEdited,
}) => {
  const togglePreviewModal = useModalToggle(ApplicationModal.SWAP_ORDER_PREVIEW)

  if (!order) {
    togglePreviewModal()
    return null
  }

  return (
    <V6OrderPreview
      order={order}
      slippage={slippage}
      setLockOrder={setLockOrder}
      isUseAllowanceTarget={isUseAllowanceTarget}
      setIsUserEdited={setIsUserEdited}
    />
  )
}

export default OrderPreview
